import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ServiceProviderService} from '../../../../core/services/service-provider.service';
import {ServiceProviderInterface} from '../../../../core/interfaces/service-provider.interface';

@Component({
  selector: 'app-modal-service-provider',
  templateUrl: './modal-service-provider.component.html',
  styleUrls: ['./modal-service-provider.component.scss']
})
export class ModalServiceProviderComponent implements OnInit, OnDestroy {
 protected searcheable = true;
 protected observables$ = [];
 @Output() selected$: EventEmitter<ServiceProviderInterface> = new EventEmitter();
  constructor(protected service: ServiceProviderService) {
    this.observables$.push(
      this.service.saveOnSuccessfull$.subscribe((data) => this.searcheable = true));
    this.observables$.push(
      this.service.serviceProviderSelected$.subscribe((data) => this.selected$.emit(data)));
  }

  ngOnInit() {
  }
  ngOnDestroy(): void {
    this.observables$.forEach((item) => item.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/service-provider/components/modal-service-provider/modal-service-provider.component.ts